@if (!isMobile) {
    <div class="bin-collection-container">
        <app-bin-collection-history></app-bin-collection-history>
        <app-bin-collection-pie></app-bin-collection-pie>
        <app-bin-analytics></app-bin-analytics>
    </div>
}

@if (isMobile) {

}